//@flow
import React from 'react';

import {makeStyles, TableCell} from '@material-ui/core';
import CustomTextField from '../../../../../elements/CustomTextField/CustomTextField';
import {useProductVariantContext} from '../../../context/productVariant';
import {
  useProductVariantRequestContext,
  useVariantMixAndMatch,
} from '../../../context/productVariantRequest';
import {useProductContext} from '../../../context';

const useStyles = makeStyles(theme => ({
  numberField: {
    width: '120px',
  },
}));

export default function VariantOfferPriceCell() {
  const classes = useStyles();
  const variant = useProductVariantContext();
  const variantRequest = useProductVariantRequestContext();

  const [product] = useProductContext(product => {
    const taxes = product.taxes ?? [];
    const categoryTaxes = product.categoryTaxes ?? [];

    return {
      id: product.id,
      taxes: [...taxes, ...categoryTaxes]
        .map(parseFloat)
        .reduce((a, b) => a + b, 1),
    };
  });

  const [mixNMacthEnabled] = useVariantMixAndMatch();

  const handleChange = price => {
    const withTaxPrice = price
      ? parseFloat(Number(price) * product.taxes).toFixed(5)
      : '';
    variantRequest.setOfferPrice(variant.id, price);
    variantRequest.setTaxedOfferPrice(variant.id, withTaxPrice);
  };

  if (!variant || !variantRequest) return null;

  return (
    <TableCell component="th" scope="row">
      <CustomTextField
        name="offerPrice"
        value={variant.offerPrice}
        className={classes.numberField}
        type="number"
        defaultValue={variant.offerPrice}
        inputProps={{
          step: '0.01',
        }}
        disabled={mixNMacthEnabled}
        onChange={e => handleChange(e.target.value)}
      />
    </TableCell>
  );
}
